import { FormattedMessage } from 'dibs-react-intl';
import styles from './styles/CheckoutSideRailDisclaimer.scss';

function CheckoutSideRailDisclaimer() {
    return (
        <div className={styles.disclaimer}>
            <FormattedMessage
                id="checkout.CheckoutSideRailDisclaimer.disclaimer"
                defaultMessage="You will only be charged if the seller accepts your offer. Offers are valid for 7 days."
            />
        </div>
    );
}

export default CheckoutSideRailDisclaimer;
